import React, { useState } from 'react'
import dayjs from 'dayjs'
import useBlockList from '../../hooks/queries/useBlockList'
import MainContentDiv from '../../components/templates/MainContent'
import * as S from './styles'
import SearchContainer from '../../components/organisms/SearchContainer'
import Search from '../Search'
import ContentsTitle from '../../components/molecules/ContentsTitle'
import commaSeparator from '../../utils/number'
import PaginationSingle from '../../components/molecules/PaginationSingle'
import ContentsWrapper from '../../components/organisms/ContentsWrapper'
import Table from '../../components/molecules/Table'
import { weiToEther } from '../../utils/dataFormat'
import PageLoading from '../../components/organisms/PageLoading'
import { Block } from '../../api/block/response'
import { PAGE_SIZE } from '../../constants'
import usePagination from '../../hooks/usePagination'
import { getPageParams } from '../../utils/params'

function BlocksList() {
  const [currentPage, setCurrentPage] = useState(getPageParams())

  const {
    blockListRes = {
      totalPage: 0,
      totalBlock: 0,
      blockList: [],
    },
    isLoading,
  } = useBlockList(currentPage, PAGE_SIZE)

  const { onNext, onPrev, onFirst, onLast } = usePagination({
    currentPage,
    setCurrentPage,
    totalPage: blockListRes.totalPage,
  })

  return (
    <MainContentDiv>
      <S.Wrapper>
        {' '}
        <SearchContainer>
          <Search />
        </SearchContainer>
        <ContentsTitle
          title="Blocks"
          subTitle={
            <S.TableTit>
              <p>
                A total of <S.TranNumSpan>{commaSeparator(blockListRes.totalBlock)}</S.TranNumSpan> Blocks
              </p>
            </S.TableTit>
          }
        />
        <PaginationSingle
          totalPage={blockListRes.totalPage}
          current={currentPage}
          onClickLeft={onPrev}
          onClickRight={onNext}
          onClickFirstPage={onFirst}
          onClickLastPage={onLast}
        />
        <ContentsWrapper>
          <Table
            columns={[
              { title: 'Block Height', dataIndex: '0', style: { maxWidth: '190px', minWidth: '0px' } },
              { title: 'Age', dataIndex: '1', style: { maxWidth: '190px', minWidth: '0px' } },
              { title: 'Transactions', dataIndex: '2', style: { maxWidth: '190px', minWidth: '0px' } },
              { title: 'Block Reward', dataIndex: '3', style: { maxWidth: '190px', minWidth: '0px' } },
            ]}
            dataSource={blockListRes.blockList.map((block: Block) => {
              return {
                '0': <S.TableLink to={`/block/${block.blockNumber}`}>{block.blockNumber}</S.TableLink>,
                '1': <>{dayjs.unix(Number(block.timestamp)).fromNow()} </>,
                '2': <S.TableLink to={`/block/${block.blockNumber}/txs`}>{commaSeparator(block.txCount)}</S.TableLink>,
                '3': (
                  <>
                    {weiToEther(block.blockReward)} {block.symbol}
                  </>
                ),
              }
            })}
            loading={isLoading}
          />
        </ContentsWrapper>
        <PaginationSingle
          totalPage={blockListRes.totalPage}
          current={currentPage}
          onClickLeft={onPrev}
          onClickRight={onNext}
          onClickFirstPage={onFirst}
          onClickLastPage={onLast}
        />
      </S.Wrapper>
      <PageLoading loading={isLoading} />
    </MainContentDiv>
  )
}

export default BlocksList
